// Validation function for checking if a password is valid (example: min 6 chars, 1 number)
function validatePassword(password) {
  // Check if the password is at least 8 characters long
  const lengthCheck = /.{8,}/.test(password);
  // Check if the password includes at least one lowercase letter
  const lowercaseCheck = /[a-z]/.test(password);
  // Check if the password includes at least one uppercase letter
  const uppercaseCheck = /[A-Z]/.test(password);
  // Check if the password includes at least one number or special character
  const specialCheck = /[0-9!@#$%^&*(),.?":{}|<>]/.test(password);
  return {
    lengthCheck,
    lowercaseCheck,
    uppercaseCheck,
    specialCheck,
  };
}

function liveValidatePassword(formId) {
  const passwordError = document.getElementById(
    `${formId}-password-requirements`
  );
  passwordError.style.display = "none";
  const passwordInput = document.getElementById(`${formId}-password`);
  passwordInput.addEventListener("input", function () {
    passwordError.style.display = "block";
    const password = this.value;
    const validationResult = validatePassword(password);

    if (
      validationResult.lengthCheck &&
      validationResult.lowercaseCheck &&
      validationResult.uppercaseCheck &&
      validationResult.specialCheck
    ) {
      passwordError.style.display = "none";
    }

    // Update feedback messages
    document.getElementById(`${formId}-length-check`).style.color =
      validationResult.lengthCheck ? "green" : "red";
    document.getElementById(`${formId}-lowercase-check`).style.color =
      validationResult.lowercaseCheck ? "green" : "red";
    document.getElementById(`${formId}-uppercase-check`).style.color =
      validationResult.uppercaseCheck ? "green" : "red";
    document.getElementById(`${formId}-special-check`).style.color =
      validationResult.specialCheck ? "green" : "red";

    // Update error message visibility
    const allValid = Object.values(validationResult).every(
      (isValid) => isValid
    );
    document.getElementById(`${formId}-password-error`).style.display = allValid
      ? "none"
      : "block";
  });
}

function showPassword(
  inputPasswordId,
  passwordToggleBtnClass,
  eyeOpenClass,
  eyeClosedClass
) {
  const passwordInput = document.getElementById(`${inputPasswordId}`);
  const passwordToggleBtn = document.querySelector(
    `.${passwordToggleBtnClass}`
  );

  const eyeClosedIcon = document.querySelector(eyeClosedClass || ".eye-closed");
  const eyeOpenIcon = document.querySelector(eyeOpenClass || ".eye-open");

  if (passwordToggleBtn && passwordInput) {
    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      eyeClosedIcon.style.display = "none";
      eyeOpenIcon.style.display = "block";
    } else {
      passwordInput.type = "password";
      eyeClosedIcon.style.display = "block";
      eyeOpenIcon.style.display = "none";
    }
  }
}
function validateName(name) {
  // console.log('name ----', name);
  const namePattern = /^[A-Za-z\s]+$/; // Allows only letters and spaces
  return namePattern.test(name.trim());
}
function validateSingaporePhoneNumber(tel) {
  if (!tel) return false; // Ensure we have a valid input

  const phoneNumber = tel.value.trim();

  // Define the regex patterns to match both cases
  const patternWith65 = /^65[89]\d{7}$/; // Matches numbers with '65' prefix
  const patternWithout65 = /^[89]\d{7}$/; // Matches numbers without '65' prefix

  // Test the phone number against both regex patterns
  return patternWith65.test(phoneNumber) || patternWithout65.test(phoneNumber);
}

function validatePhone(phoneId) {
  document.getElementById(phoneId).addEventListener("change", function () {
    let phoneNumber = this.value.trim();

    // Check if the phone number is without '65' and starts with 8 or 9
    if (!phoneNumber.startsWith("65") && /^[89]\d{7}$/.test(phoneNumber)) {
      // Do nothing, it's already valid without '65'
      return;
    }

    // Check if the phone number starts with '65' and follows the valid pattern
    if (
      phoneNumber.startsWith("65") &&
      /^[89]\d{7}$/.test(phoneNumber.slice(2))
    ) {
      // Do nothing, it's already valid with '65'
      return;
    }

    // If the phone number doesn't fit either case, consider it invalid (or handle accordingly)
    // For this function, we won't auto-correct; we just exit
  });
}

function validateEmail(email) {
  if (!email) return;
  // console.log('email ----', email.value);
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email.value.trim());
}

function setDateRange(inputId) {
  const dateInput = document.getElementById(inputId);

  if (dateInput) {
    // Get today's date
    const today = new Date();

    // Calculate the minimum date (10 years back from today)
    const minDate = new Date(
      today.getFullYear() - 10,
      today.getMonth(),
      today.getDate()
    );
    const minDateString = minDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD

    // Calculate the maximum date (1 year in the future from today)
    const maxDate = new Date(
      today.getFullYear() + 1,
      today.getMonth(),
      today.getDate()
    );
    const maxDateString = maxDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD

    // Apply min and max date to the input
    dateInput.setAttribute("min", minDateString);
    dateInput.setAttribute("max", maxDateString);

    // console.log('Min Date:', minDateString, 'Max Date:', maxDateString);
  }
}

function attachFormValidation(formId) {
  const form = document.getElementById(formId);
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const isValid = validateForm(form);
      if (isValid) {
        form.submit(); // Submit the form if validation passes
      }
    });
  }
}

function generalMetaFieldsSetter(formId) {
  const form = document.getElementById(formId);
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const isValid = validateForm(form);
      if (isValid) {
        form.submit(); // Submit the form if validation passes
      }
    });
  }
}

//validateField, takes in an id
const validateField = (field) => {
  console.log("validating", field.id);
  const errorElement = document.querySelector(`#${field.id}-error`);

  console.log("error element is", errorElement);

  if (!errorElement) return true; // If no error element is associated, assume valid

  let isFieldValid = true;

  // Run validation based on field type or custom rules
  if (field.type === "tel") {
    isFieldValid = validateSingaporePhoneNumber(field, errorElement);
  } else if (field.type === "email") {
    isFieldValid = validateEmail(field, errorElement);
  } else if (field.type === "password" || field.id.includes("password")) {
    if (field.id.includes("confirmation")) {
      const password = document.getElementById(
        field.id.replace("_confirmation", "")
      ).value;
      isFieldValid = field.value === password;
      const errorElementConfirmation = document.querySelector(
        `#${field.id}-password_confirmation-error`
      );
      if (!isFieldValid && errorElementConfirmation) {
        // errorElementConfirmation.textContent = 'Passwords do not match';
      }
    } else {
      const password = field.value;
      const validationResult = validatePassword(password);
      isFieldValid = Object.values(validationResult).every(
        (isValid) => isValid
      );
      if (!isFieldValid) {
        // errorElement.textContent = 'Invalid password format';
      }
    }
  } else if (field.type === "text") {
    if (field.id.includes("address")) {
      // isFieldValid = true;
      isFieldValid = field.value.trim().length ? true : false;
    } else {
      isFieldValid = validateName(field.value);
      // if (!isFieldValid) {
      // 	errorElement.textContent = `{{ 'snippets.shared-forms.invalid_name' | t }} `;
      // }
    }
  } else if (field.type === "checkbox") {
    isFieldValid = field.checked;
  } else if (field.required && !field.value.trim()) {
    isFieldValid = false;
    // errorElement.textContent = ` {{-  'snippets.shared-forms.required_field' | t -}} `;
  }

  // Show or hide the error message based on validity
  errorElement.style.display = isFieldValid ? "none" : "block";

  const loader = document.getElementById("general-loader");
  const submitButton = document.getElementById("general-submit-button");
  if (loader) {
    loader.style.display = "none";
  }
  if (submitButton) {
    submitButton.disabled = false;
  }
  return isFieldValid;
};

const attachValidationEvents = (formContainer) => {
  const fields = formContainer.querySelectorAll("[required]");

  fields.forEach((field) => {
    field.addEventListener("input", () => validateField(field));
    field.addEventListener("change", () => validateField(field));
  });
};

//validateForm function : takes in everything that has a required field and runs validateFields on it

const validateForm = (formContainer) => {
  const requiredFields = formContainer.querySelectorAll("[required]");
  let isFormValid = true;

  requiredFields.forEach((field) => {
    const isFieldValid = validateField(field);
    if (!isFieldValid) {
      isFormValid = false; // If any field is invalid, the form is invalid
    }
  });
  // console.log('isFormValid', isFormValid);
  return isFormValid;
};
